import { CustomTableService } from './custom-table.service';

export const services = [CustomTableService];

export * from './custom-table.service';
